module.exports = __webpack_public_path__ + "static/media/callMute.2145ace0.svg";